const types = require('constants/actionTypes');

const resultClosed = () => ({ type: types.GLOSSARY_RESULT_CLOSED });

module.exports = resultClosed;
